module.exports = __webpack_public_path__ + "img/logo_haifa.130b966f.png";